import React from "react";
import { products } from "../data/mock";
import { ProductCard, JoinBand, Reveal, Kick } from "../components/Shared";
import Seo, { breadcrumbSchema } from "../components/Seo";

export default function Shop() {
  return (
    <>
      <Seo
        title="Shop Warrior Wall Art & Canvas Prints | Ninja Athletic Club"
        description="Gallery-grade motivational canvas prints forged from warrior philosophy. Drop 001 cinematic prints and Drop 002, the Statement Series. From $79."
        path="/shop"
        schemas={[
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Shop", path: "/shop" },
          ]),
        ]}
      />
      <header className="page-hero">
        <span className="bigkanji" aria-hidden="true">刀</span>
        <div className="wrap">
          <Kick k="刀">The Collection</Kick>
          <h1>
            The art of war, <span className="ol">framed.</span>
          </h1>
          <p className="lede">
            Ninja Athletic Club prints are gallery-grade canvas forged from warrior philosophy. Drop 001 is the
            cinematic set. Drop 002 is the Statement Series, eighteen typographic pieces from the scrolls. Hover any
            print to see the raw artwork.
          </p>
        </div>
      </header>

      <div className="shopgrid">
        <div className="wrap">
          <div className="dropnote">
            <span className="dot" aria-hidden="true"></span>
            Drop 001 is in production. Join the waitlist on any print and you will be first when it ships.
          </div>
          <div className="grid3">
            {products.filter((p) => p.drop === "001").map((p, i) => (
              <ProductCard key={p.slug} p={p} delay={`d${i + 1}`} />
            ))}
          </div>

          <div style={{ marginTop: 96 }}>
            <Reveal>
              <Kick k="言">Drop 002 · The Statement Series</Kick>
              <h2 className="sec">Words that hold the standard.</h2>
              <p className="lede" style={{ marginTop: 14, maxWidth: 640 }}>
                Eighteen typographic canvases pulled straight from the scrolls. Heavy condensed type on near-black,
                one statement per wall. Every piece has a full dispatch behind it in the mindset hub.
              </p>
            </Reveal>
          </div>
          <div className="grid3" style={{ marginTop: 40 }}>
            {products.filter((p) => p.drop === "002").map((p, i) => (
              <ProductCard key={p.slug} p={p} delay={`d${(i % 3) + 1}`} />
            ))}
          </div>

          <div style={{ marginTop: 64 }}>
            <Reveal className="labbox">
              <div>
                <p className="lb-tag">Sizing</p>
                <p>
                  Every print ships in three sizes. 12 x 18 from $79, 18 x 27 from $119, and the statement 24 x 36
                  from $159. All framed, all ready to hang.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>

      <JoinBand />
    </>
  );
}
